export default __webpack_public_path__ + "static/media/avatar.3df1cf94.jpg";